import { deprecatedGenerateEventsDefinition, generateEventsFromEnum } from '@guiker/event'

import { PropertyOwnership } from '../../entity'
import { baseEvent } from '../base'

const basePropertyOwnershipEvent = {
  ...baseEvent,
  entity: 'PROPERTY_OWNERSHIP',
  data: null as unknown as PropertyOwnership,
}

export enum PropertyOwnershipEventTypes {
  OWNER_CHANGED_ON_CREATION = 'OWNER_CHANGED_ON_CREATION',
  PROPERTY_OWNERSHIP_MIGRATED = 'PROPERTY_OWNERSHIP_MIGRATED',
}

export const PropertyOwnershipEventsDefinition = deprecatedGenerateEventsDefinition({
  ...basePropertyOwnershipEvent,
  eventTypes: PropertyOwnershipEventTypes,
})

export const PropertyOwnershipEvents = generateEventsFromEnum(basePropertyOwnershipEvent)(PropertyOwnershipEventTypes)
